import FeedbackButtons from './FeedbackButtons';

export default FeedbackButtons;
